/* eslint-disable warp-drive/no-legacy-request-patterns */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import {
  isMobile,
  isTWA,
} from '@linc-technologies/linced-common/utils/platform';

export default class ApplicationDataService extends Service {
  // Services
  @service
  logging;

  @service
  options;

  @service
  policyAcceptance;

  @service
  pushNotifications;

  @service
  session;

  @service
  store;

  // Preloaded data properties
  @tracked
  pages = [];

  // This is commented out because we do this up front in the application route atm.
  // If we ever want to lazy load, uncomment this
  /*async init() {
    this._super(...arguments);

    // load all application data after we have loaded user data and have auth
    // Note: session.ensure() is intentionally not called here — startup.js
    // guarantees auth is set up before model() is called for authenticated routes.
    await this.load();
  },*/

  attachDeviceNotifications() {
    // Ensure we get notifications on this device
    if (isMobile() || isTWA()) {
      this.pushNotifications.attachDevice(this.session.personId);
    }
  }

  async load() {
    if (isEmpty(this.session.activeSchool)) {
      return;
    }

    // Only load policies (currently NZ-only) if the school is NZ jurisdiction.
    if (this.session.school.jurisdiction === Jurisdiction.NZ_MOE) {
      this.policyAcceptance.loadPolicies();
    }

    //// Preload any useful data here, including what we want to return as the application route's model.
    let [pages] = await Promise.all([
      // Load Pages for the user's school
      this.store.findAll('posts/page'),
      this.store.findAll('assessments/assessment'),
      // Preload staff names for comment authorship etc.
      this.store.query('person', { type: PersonType.STAFF }),
      // Preload caregiver names for comment authorship etc.
      this.store.query('person', { type: PersonType.CAREGIVER }),
    ]);

    this.pages = pages;

    this.attachDeviceNotifications();

    this.logging.pushEvent('applicationData:loaded');
  }
}
